import { DashboardWrapper } from "../../../container/dashboardWrapper"
import { Container, Heading, MainContent, MainContentWrapper } from "../../../styles/account/account";
import { Breadcrumb } from "../../../components/breadcrumb/breadcrumb";
import { SubjectList } from "../../../components/subjects/subject-list/subject-list";

const Subjects = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Subjects
                        </Heading>
                        <Breadcrumb
                            crumbs={['Subjects']}
                        />
                        <SubjectList />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Subjects
